import React from "react";

const BRANDS = [
  "TOYOTA",
  "HONDA",
  "NISSAN",
  "FORD",
  "HYUNDAI",
  "MAZDA",
  "CHEVROLET",
  "KIA",
  "SUBARU",
  "VOLKSWAGEN",
];

const Marquee = () => {
  const items = [...BRANDS, ...BRANDS];
  return (
    <div
      className="overflow-hidden border-y border-white/5 py-10 bg-[#070707]"
      data-testid="brand-marquee"
    >
      <div className="marquee-track">
        {items.map((b, i) => (
          <span key={i} className="brand-marquee">
            {b}
            <span className="mx-12 text-[#FFB400]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
